import React from 'react';
import PropTypes from 'prop-types';
import CustomEditor from '../../../shared/molecules/CustomEditor';

const JsonView = ({ schema }) => {
  return (
    <CustomEditor
      theme="json-editor-theme"
      defaultLanguage="json"
      value={JSON.stringify(schema ?? {}, undefined, 2)}
      height={360}
      options={{
        readOnly: true,
      }}
    />
  );
};

JsonView.propTypes = {
  schema: PropTypes.object,
};

export default JsonView;
